<app-dialog-header [title]="'PHOTO_EDITOR.TITLE'" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="editor-content px-24 py-0">
    <div class="crop-container">
        <img #image [src]="imageSource" alt="To crop" />
    </div>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center" class="px-24">
    <div fxLayout="row">
        <button mat-icon-button (click)="zoomIn()" [matTooltip]="'PHOTO_EDITOR.LABEL.ZOOM_IN' | translate" matTooltipPosition="above"><mat-icon>zoom_in</mat-icon></button>
        <button mat-icon-button (click)="zoomOut()" [matTooltip]="'PHOTO_EDITOR.LABEL.ZOOM_OUT' | translate" matTooltipPosition="above"><mat-icon>zoom_out</mat-icon></button>
        <button mat-icon-button (click)="rotate()" [matTooltip]="'PHOTO_EDITOR.LABEL.ROTATE' | translate" matTooltipPosition="above"><mat-icon>rotate_right</mat-icon></button>
        <button mat-icon-button (click)="reset()" [matTooltip]="'PHOTO_EDITOR.LABEL.REFRESH' | translate" matTooltipPosition="above"><mat-icon>refresh</mat-icon></button>
    </div>

    <div fxLayout="row">
        <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
        <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (click)="save()" [isLoading]="myImageApiService.uploadingCroppedImage$ | async"></app-flat-button>
    </div>
</div>
